import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/painel-seo")({
  beforeLoad: () => {
    throw redirect({ to: "/seo", statusCode: 301 });
  },
});
